import { BFFClient } from "services/client";
import type {
  ECreateCommentDto,
  IAttachment,
  IComment,
  ITicket,
} from "types/support-tickets";
import {
  BFF_SUPPORT_GET_ATTACHMENT,
  BFF_SUPPORT_TICKETS_COMMENT_ENDPOINT,
  BFF_SUPPORT_TICKETS_ENDPOINT,
} from "utils/urls";

async function fetchTicket(token: string, ticketId?: string): Promise<ITicket> {
  const ticket = await BFFClient(token).get(
    BFF_SUPPORT_TICKETS_ENDPOINT(ticketId)
  );

  return ticket.data;
}

async function fetchTicketAttachment(
  token: string,
  attachmentId: string
): Promise<IAttachment> {
  const ticket = await BFFClient(token).get(
    BFF_SUPPORT_GET_ATTACHMENT.replace(":id", attachmentId)
  );

  return ticket.data;
}

async function createComment(
  ticketId,
  body: ECreateCommentDto,
  token: string
): Promise<IComment> {
  const comment = await BFFClient(token).post(
    BFF_SUPPORT_TICKETS_COMMENT_ENDPOINT(ticketId),
    body
  );

  return comment.data;
}

export const supportTicketsService = {
  fetchTicket,
  createComment,
  fetchTicketAttachment,
};
